import DIcon from '~@/Components/Common/DIcon'
import DButton from '~@/Components/Common/DButton'
import DButtonDropdown from '~@/Components/Common/Dropdown/DButtonDropdown'
import DDropdownItem from '~@/Components/Common/Dropdown/DDropdownItem'
import DDropdownSpacer from '~@/Components/Common/Dropdown/DDropdownSpacer'
import DCard from '~@/Components/Common/DCard'
import DFormRow from '~@/Components/Common/Forms/DFormRow'
import DFormControls from '~@/Components/Common/Forms/DFormControls'
import DFabs from '~@/Components/Common/DFabs'
import DFab from '~@/Components/Common/DFab'
import DModal from '~@/Components/Common/DModal'
import DTabs from '~@/Components/Common/DTabs'
import DTabItem from '~@/Components/Common/DTabItem'
import DTag from '~@/Components/Common/DTag'
import DDateInput from '~@/Components/Common/Forms/DDateInput'
import DDateFormatInput from '~@/Components/Common/Forms/DDateFormatInput.vue'
import DPhoneInput from '~@/Components/Common/Forms/DPhoneInput'
import DTriStateCheckbox from '~@/Components/Common/Forms/DTriStateCheckbox'
import DInput from '~@/Components/Common/Forms/DInput'
import DSecretInput from '~@/Components/Common/Forms/DSecretInput.vue'
import DFormCheck from '~@/Components/Common/Forms/DFormCheck'
import DSelect from '~@/Components/Common/Forms/DSelect'
import DInputGroup from '~@/Components/Common/Forms/DInputGroup'
import DRow from '~@/Components/Common/DRow'
import DCol from '~@/Components/Common/DCol'
import DDropdown from '~@/Components/Common/Dropdown/DDropdown'
import DFormTextarea from '~@/Components/Common/Forms/DFormTextarea'
import DJsonTextarea from '~@/Components/Common/Forms/DJsonTextarea.vue'
import DRadioGroup from '~@/Components/Common/Forms/DRadioGroup'
import DForm from '~@/Components/Common/Forms/DForm'
import DSwitch from '~@/Components/Common/Forms/DSwitch.vue'
import DPagination from '~@/Components/Common/DPagination.vue'
import DTable from '~@/Components/Common/DTable.vue'
import DFileInput from '~@/Components/Common/Forms/DFileInput.vue'
import DCardBody from '~@/Components/Common/DCardBody.vue'
import DAlert from '~@/Components/Common/DAlert.vue'
import DListGroup from '~@/Components/Common/DListGroup.vue'
import DListGroupItem from '~@/Components/Common/DListGroupItem.vue'
import DWrapper from '~@/Components/Common/DWrapper.vue'
import DWidgetBrand from '~@/Components/Common/DWidgetBrand.vue'
import DCollapse from '~@/Components/Common/DCollapse.vue'
import DToaster from '~@/Components/Common/DToaster.vue'
import DToast from '~@/Components/Common/DToast.vue'
import DCardHeader from '~@/Components/Common/DCardHeader.vue'
import DBadge from '~@/Components/Common/DBadge.vue'
import DMultiSelect from '~@/Components/Common/Forms/DMultiSelect.vue'
import DCardText from '~@/Components/Common/DCardText.vue'
import DCardTitle from '~@/Components/Common/DCardTitle.vue'
import DAdvancedMultiSelect from '~@/Components/Common/Forms/DAdvancedMultiSelect.vue'
import DChartBarSimple from '~@/Components/Common/Widgets/DChartBarSimple.vue'
import DRichTextEditor from '~@/Components/Common/DRichTextEditor.vue'
import DInputGroupText from '~@/Components/Common/Forms/DInputGroupText.vue'
import DDualListSelector from '~@/Components/Common/DDualListSelector.vue'
import DTooltip from '~@/Components/Common/DTooltip.vue'
import { Head } from '@inertiajs/vue3'

const DogadoComponents = {
    install (Vue, options) {
        Vue.component('DIcon', DIcon)
        Vue.component('DButton', DButton)
        Vue.component('DButtonDropdown', DButtonDropdown)
        Vue.component('DDropdownItem', DDropdownItem)
        Vue.component('DDropdownSpacer', DDropdownSpacer)
        Vue.component('DCard', DCard)
        Vue.component('DCardBody', DCardBody)
        Vue.component('DFormRow', DFormRow)
        Vue.component('DFormControls', DFormControls)
        Vue.component('DFabs', DFabs)
        Vue.component('DFab', DFab)
        Vue.component('DModal', DModal)
        Vue.component('DTabs', DTabs)
        Vue.component('DTabItem', DTabItem)
        Vue.component('DTag', DTag)
        Vue.component('DDateInput', DDateInput)
        Vue.component('DDateFormatInput', DDateFormatInput)
        Vue.component('DPhoneInput', DPhoneInput)
        Vue.component('DTriStateCheckbox', DTriStateCheckbox)
        Vue.component('DInput', DInput)
        Vue.component('DSecretInput', DSecretInput)
        Vue.component('DFileInput', DFileInput)
        Vue.component('DFormCheck', DFormCheck)
        Vue.component('DSelect', DSelect)
        Vue.component('DRow', DRow)
        Vue.component('DCol', DCol)
        Vue.component('DInputGroup', DInputGroup)
        Vue.component('DDropdown', DDropdown)
        Vue.component('DFormTextarea', DFormTextarea)
        Vue.component('DJsonTextarea', DJsonTextarea)
        Vue.component('DRadioGroup', DRadioGroup)
        Vue.component('DForm', DForm)
        Vue.component('DSwitch', DSwitch)
        Vue.component('DPagination', DPagination)
        Vue.component('DTable', DTable)
        Vue.component('DAlert', DAlert)
        Vue.component('DListGroup', DListGroup)
        Vue.component('DListGroupItem', DListGroupItem)
        Vue.component('DWrapper', DWrapper)
        Vue.component('DWidgetBrand', DWidgetBrand)
        Vue.component('DCollapse', DCollapse)
        Vue.component('DToaster', DToaster)
        Vue.component('DToast', DToast)
        Vue.component('DCardHeader', DCardHeader)
        Vue.component('DBadge', DBadge)
        Vue.component('DMultiSelect', DMultiSelect)
        Vue.component('DCardText', DCardText)
        Vue.component('DCardTitle', DCardTitle)
        Vue.component('DAdvancedMultiSelect', DAdvancedMultiSelect)
        Vue.component('DChartBarSimple', DChartBarSimple)
        Vue.component('DRichTextEditor', DRichTextEditor)
        Vue.component('DInputGroupText', DInputGroupText)
        Vue.component('DDualListSelector', DDualListSelector)
        Vue.component('DTooltip', DTooltip)
        Vue.component('Head', Head)
    }
}

export default DogadoComponents
